import { useEffect, useState } from "react";

// No hay un hook reutilizable equivalente en el repo (los `window.innerWidth` existentes son
// comprobaciones puntuales, p.ej. ContentCardComponentV2.js); breakpoint 768 según diseño §17.
export const useIsMobile = (breakpoint = 768) => {
  const query = `(max-width: ${breakpoint - 1}px)`;
  const [isMobile, setIsMobile] = useState(() => (typeof window !== "undefined" ? window.matchMedia(query).matches : false));

  useEffect(() => {
    const mql = window.matchMedia(query);
    const handler = (e) => setIsMobile(e.matches);
    mql.addEventListener ? mql.addEventListener("change", handler) : mql.addListener(handler);
    return () => (mql.removeEventListener ? mql.removeEventListener("change", handler) : mql.removeListener(handler));
  }, [query]);

  return isMobile;
};
